module.exports = __webpack_public_path__ + "img/eye.c7cf5c98.svg";